import type { InstructionCategoryType } from '@terra/shared-contracts-applications';
import { InstructionCategorySchema } from '@terra/shared-schemas-orchestrator';
import type { TestingInstructionsTargetKind } from './types';

export const resolveSelectableInstructionCategories = ({
  targetKind,
  isDeepSecurityScanEnabled,
}: {
  targetKind: TestingInstructionsTargetKind;
  isDeepSecurityScanEnabled: boolean;
}): InstructionCategoryType[] => {
  const includeDeepSecurityScan =
    targetKind === 'web-application' && isDeepSecurityScanEnabled;

  return InstructionCategorySchema.options.filter(
    (category) =>
      includeDeepSecurityScan ||
      category !== InstructionCategorySchema.enum.DEEP_SECURITY_SCAN,
  );
};
